import { useContext, useMemo, useState } from 'react'
import DishCard from '../components/DishCard'
import SearchBar from '../components/SearchBar'
import HeadTitle from '../layout/HeadTitle'
import { UserContext } from '../layout/Root'
import data from '../utils/data.json'

export default function Home() {
   const [search, setSearch] = useState('')
   const [type, setType] = useState('')
   const [user] = useContext(UserContext)


   const dataFilteredByCat = useMemo(() => type ? data.filter(d => d.type === type) : data, [type, search])
   const dataFiltered = useMemo(() => dataFilteredByCat.filter(d => d.title.includes(search) || d.desc.includes(search)), [search, type])

   return (
      <>
         <HeadTitle title={`Menu ( ${dataFiltered.length} ) `} />
         <div className="container">
            <SearchBar setSearch={setSearch} setType={setType} />
            <div className="row">
               {dataFiltered.map((d, i) =>
                  <div key={d.title} className="col-md-4 col-lg-3 col-sm-12 p-2">
                     <DishCard index={i} type={user?.type} d={d} />
                  </div>
               )}
            </div>
         </div>
      </>
   )
}
